import DisplayHomeLogo from "../../assets/logos/Display-Home-Logo.png";
import DisplayBusinessLogo from "../../assets/logos/Display-Business-Logo.png";
import OikosEduIcon from "../../assets/logos/Oikos_EDU_icon.png";
import OikosEduLogo from "../../assets/logos/Oikos_EDU_logo.png";
import AdminLogo from "../../assets/logos/Admin-logo.png";
import CampusLogo from "../../assets/logos/Campus-Logo.png";
import PagesLogo from "../../assets/logos/Pages-Logo.png";
import SportsLogo from "../../assets/logos/Sports-Logo.png";
import CampusBackground from "../../assets/backgrounds/Campus-Background.png";
import ClassroomLoginBackground from "../../assets/backgrounds/Classroom Login Background.png";
import EduLoginBackground from "../../assets/backgrounds/EDU Login Background.png";

const FarmIcon = "/app-icons/farm-icon.svg";
const NightstandIcon = "/app-icons/nightstand-icon.svg";

export const BRAND_ASSET_KEYS = Object.freeze({
  ADMIN_LOGO: "oikos.admin.logo",
  BUSINESS_LOGO: "oikos.business.logo",
  CAMPUS_BACKGROUND: "oikos.campus.background",
  CAMPUS_LOGO: "oikos.campus.logo",
  CLASSROOM_LOGIN_BACKGROUND: "oikos.classroom.loginBackground",
  EDU_ICON: "oikos.edu.icon",
  EDU_LOGIN_BACKGROUND: "oikos.edu.loginBackground",
  EDU_LOGO: "oikos.edu.logo",
  FARM_ICON: "oikos.farm.icon",
  HOME_LOGO: "oikos.home.logo",
  NIGHTSTAND_ICON: "oikos.nightstand.icon",
  PAGES_LOGO: "oikos.pages.logo",
  SPORTS_LOGO: "oikos.sports.logo",
});

export const staticBrandAssets = Object.freeze({
  [BRAND_ASSET_KEYS.ADMIN_LOGO]: {
    kind: "logo",
    src: AdminLogo,
  },
  [BRAND_ASSET_KEYS.BUSINESS_LOGO]: {
    kind: "logo",
    src: DisplayBusinessLogo,
  },
  [BRAND_ASSET_KEYS.CAMPUS_BACKGROUND]: {
    kind: "background",
    src: CampusBackground,
  },
  [BRAND_ASSET_KEYS.CAMPUS_LOGO]: {
    kind: "logo",
    src: CampusLogo,
  },
  [BRAND_ASSET_KEYS.CLASSROOM_LOGIN_BACKGROUND]: {
    kind: "background",
    src: ClassroomLoginBackground,
  },
  [BRAND_ASSET_KEYS.EDU_LOGIN_BACKGROUND]: {
    kind: "background",
    src: EduLoginBackground,
  },
  [BRAND_ASSET_KEYS.EDU_ICON]: {
    kind: "icon",
    src: OikosEduIcon,
  },
  [BRAND_ASSET_KEYS.EDU_LOGO]: {
    kind: "logo",
    src: OikosEduLogo,
  },
  [BRAND_ASSET_KEYS.FARM_ICON]: {
    kind: "icon",
    src: FarmIcon,
  },
  [BRAND_ASSET_KEYS.HOME_LOGO]: {
    kind: "logo",
    src: DisplayHomeLogo,
  },
  [BRAND_ASSET_KEYS.NIGHTSTAND_ICON]: {
    kind: "icon",
    src: NightstandIcon,
  },
  [BRAND_ASSET_KEYS.PAGES_LOGO]: {
    kind: "logo",
    src: PagesLogo,
  },
  [BRAND_ASSET_KEYS.SPORTS_LOGO]: {
    kind: "logo",
    src: SportsLogo,
  },
});

export const modeLogoAssetKeys = Object.freeze({
  admin: BRAND_ASSET_KEYS.ADMIN_LOGO,
  business: BRAND_ASSET_KEYS.BUSINESS_LOGO,
  campus: BRAND_ASSET_KEYS.CAMPUS_LOGO,
  edu: BRAND_ASSET_KEYS.EDU_LOGO,
  farm: BRAND_ASSET_KEYS.FARM_ICON,
  home: BRAND_ASSET_KEYS.HOME_LOGO,
  nightstand: BRAND_ASSET_KEYS.NIGHTSTAND_ICON,
  pages: BRAND_ASSET_KEYS.PAGES_LOGO,
  sports: BRAND_ASSET_KEYS.SPORTS_LOGO,
  tv: BRAND_ASSET_KEYS.NIGHTSTAND_ICON,
});

export function getBrandAssetSrc(assetKey, fallback = "") {
  return staticBrandAssets[assetKey]?.src || fallback;
}

export function getModeLogoSrc(mode = "home", fallback = "") {
  return getBrandAssetSrc(modeLogoAssetKeys[mode] || BRAND_ASSET_KEYS.HOME_LOGO, fallback);
}
